import { request } from "https";
// import config from './config';
//const requestUrl = "http://api-vms-uat.dtgarden.com/api";
const requestUrl = "http://api-vms.jiaxuan-xw.com/api";
//const requestUrl = "http://127.0.0.1:8888/api";
//const requestUrl = "http://api-vms.jiaxuan-xw.com/api";
//修改接口


const warningTip = '请求不到数据或网络连接异常！'
export default {
    baseURL : requestUrl,
    timeout: 1000,
    login : requestUrl + 'login',
    logout : requestUrl + 'logout',
    userInfo : requestUrl + 'user/info',
    userList : 'user/list',

    msgSend : requestUrl + 'msg/send',
    excelImport : requestUrl + 'excel/import',
    excelExport : requestUrl + 'excel/export',
    warningTip
}
